import React from 'react'
import { Link } from 'react-router-dom';
import Herosection from '../Componet/Herosection/HerosectionL1';

// import Newsletter from '../Componet/Newsletter/NewsletterL1' 
import Feauture from '../Componet/Feature/Feature';
import Services from '../Componet/Feature/Services';
import InspectionChecklist from '../Componet/Feature/InspectionChecklist';
import WhyChooseSection from '../Componet/Feature/WhyChooseSection';
import FAQSection from '../Componet/Feature/FAQSection';

function HomePage() {
    return (
        <div>
            <Herosection />
            <div className="page-content">
                <Services />
                <Feauture />
                {/* <Counter /> */}
                {/* <Newsletter /> */}
                {/* <Blog /> */}
                <InspectionChecklist />
                <WhyChooseSection />
                <FAQSection />
                <section>
                    <div className="container">
                        <div
                            className="row justify-content-between align-items-center mb-4 mb-lg-5"
                        >
                            <div className="col-lg-12 col-md-12 text-center">
                                <div>
                                    <h2>
                                        Ready to Complete Your Vehicle Inspection
                                    </h2>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 text-center">
                                Book your online inspection and complete it from your phone through a live video call.
                            </div>
                           
                                <div className="col-lg-12  text-center">
                                    <div className="mb-5">
                                        <p className="lead mb-0">
                                        </p>
                                        <p className='mt-4'><Link className="btn btn-dark " to="quotation">Book Your Inspection</Link></p>
                                    </div>
                                </div>
                           
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default HomePage
